import { HashHistoryManager, HTML5HistoryManager } from "navigation";

import type { HistoryManagerPrototype } from "./history-guard-core";
import { installHistoryGuard } from "./history-guard-core";

// Web: zie history-guard-core.ts. Moet draaien voordat NavigationProvider zijn
// HTML5HistoryManager aanmaakt, dus op module-niveau in App.tsx.
export default function installWebHistoryGuard(fallbackUrl: string): void {
  if (typeof window === "undefined" || !window.history) {
    return;
  }
  installHistoryGuard({
    prototype: HTML5HistoryManager.prototype as unknown as HistoryManagerPrototype,
    isRootManager: (manager) => !(manager instanceof HashHistoryManager),
    getHistory: () => window.history,
    fallbackUrl,
  });
}
